<!--  场地黑名单  -->
<template>
  <table-view
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable">
    <template #header>
      <view-search-form
        ref="searchFormRef"
        :queryInfo.sync="queryInfo"
        :tool-list="['keyword']"
        @on-search="renderTable(1)">
        <el-form-item label="黑名单在列" label-width="100px">
          <el-select
            v-model="queryInfo.passFlag"
            clearable
            size="small">
            <el-option
              v-for="{value,label} in passFlagList"
              :key="value"
              :label="label"
              :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select
            v-model="queryInfo.userType"
            clearable
            size="small">
            <el-option :value="2" label="学生" />
            <el-option :value="3" label="教职工" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button fr">
        <el-button type="success" size="small" @click="exportExcel">按条件导出</el-button>
      </div>
    </template>
    <el-table :data="tableData" style="width: 100%;" border stripe>
      <el-table-column prop="stuName" label="姓名" width="220">
        <template v-slot="{row}">
          {{ row.stuName || row.teaName }}
        </template>
      </el-table-column>
      <el-table-column prop="stuName" label="用户类型" min-width="88" align="center">
        <template v-slot="{row}">
          <el-tag v-if="row.userType === 2">学生</el-tag>
          <el-tag v-if="row.userType === 3" type="success">教职工</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width="160">
        <template v-slot="{row}">
          {{ row.fixedPhone || row.teaPhone }}
        </template>
      </el-table-column>
      <el-table-column label="部门/专业班级" min-width="260">
        <template v-slot="{row}">
          <template v-if="row.className">
            {{ row.campusName }}{{ row.majorName }}{{ row.className }}
          </template>
          <template v-else>
            {{ row.teaDeptName || row.teaCollegeName }}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="移入黑名单时间" width="180" align="center"/>
      <el-table-column prop="updateTime" label="解除时间" width="180" align="center"/>
      <el-table-column label="备注" prop="remarks" min-width="200"/>
      <el-table-column label="操作" width="130" align="center" fixed="right">
        <template v-slot="{row}">
          <template v-if="row.passFlag">
            <span class="font-grey">--已移出黑名单--</span>
          </template>
          <template v-else>
            <el-button v-permission="['snooker:unblock']"
                       size="mini"
                       type="danger"
                       @click="unBlock(row)"
            >移出黑名单
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import { throttle } from 'lodash'
import { pageSnookerBlockListApi, unBlockUserSnookerApi } from '@/api/student-manage/snooker-block-list-api'

export default {
  name: 'SnookerBlockList',
  mixins: [tableView],
  data() {
    return {
      queryInfo: {
        passFlag: 0, // 黑名单状态
        userType: null
      },
      // 黑名单状态
      passFlagList: [
        {
          value: 0,
          label: '是'
        },
        {
          value: 1,
          label: '否'
        }
      ]
    }
  },
  methods: {
    async renderTable(pageNum) {
      await this.getTableData(pageSnookerBlockListApi, pageNum)
    },
    unBlock: throttle(function(row) {
      const _name = row.stuName || row.teaName
      console.log(_name)
      this.$confirm(`<p class="confirm-message">此操作将把<b class="warning"> ${_name}</b>移出桌球室黑名单，是否继续?</p>`, '移出黑名单', {
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
        .then(async () => {
          this.loading = true
          try {
            await unBlockUserSnookerApi(row.id)
            this.$message.success(`${_name}已移出黑名单!`)
            await this.renderTable()
          } catch (e) {
          } finally {
            this.loading = false
          }
        })
        .catch(() => {
          this.$message('已取消')
        })
    }, 1000, {}),
    async exportExcel () {
      try {
        await this.$http.exportExcelHttp.exportSnookerUserBlockList(this.queryInfo)
        this.$message.success('导出成功!')
      } catch (e) {
        if (!e) this.$message.error('导出失败，请重试！')
      }
    }
  }
}
</script>
